/**
 * Reserved section id for the TOP-LEVEL projects list. Unlike members/worklogs (which are
 * children of a node), the project list is the tree's roots and has no parent node, so it can't
 * come from the generic nested-pagination walker. It is registered with the shared observer
 * under this synthetic id, which is globally disjoint from every real row id (`project-…`,
 * `project-…-member-…`, `entry-…`) so combined pagination resolution stays unambiguous.
 */
export const APPROVALS_PROJECTS_SECTION_ID = '__approvals_projects__';
